//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from "vuex";
import headerTop from "@/components/header";

export default {
  name: 'app',
  components: {
    headerTop
  },
  computed: {
    ...mapState([
      "bgc"
    ])
  },
  watch: {
    'bgc': function(val, oldVal) {
      if (val) {
        document.body.style.backgroundColor = val;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue